<div class="page-container">
  <!-- HEADER -->
  <header class="page-header">
    <span class="eyebrow">Legal & Compliance</span>
    <h1 class="page-title">Privacy Policy</h1>
    <p class="page-subtitle">
      How Aluguloo LLC handles, processes, and safeguards personal and commercial entity data.
    </p>
    <div class="meta-row">
      <span>Effective: January 1, 2026</span>
      <span class="meta-dot">·</span>
      <span>Governing Law: UAE Federal Decree-Law No. 45 of 2021 (PDPL)</span>
    </div>
  </header>

  <!-- CONTENT -->
  <main class="document-content">
    <section class="doc-section">
      <h2>1. Introduction & Overview</h2>
      <p>
        Aluguloo.com is operated by <strong>Onixhu LLC</strong> ("Aluguloo", "we", "us", or "our"), a company incorporated in the 
        United Arab Emirates. Aluguloo provides a digital marketplace connecting equipment hirers ("Customers") with heavy equipment owners and fleet operators ("Vendors").
      </p>
      <p>
        We are committed to maintaining the highest confidentiality and data integrity standards in accordance with UAE federal privacy legislation.
      </p>
    </section>

    <section class="doc-section">
      <h2>2. Information We Collect</h2>
      <p>In operating the marketplace platform, we collect the following categories of information:</p>
      
      <div class="data-grid">
        <div class="data-card">
          <h3>Account & Identity</h3>
          <p>Contact name, company legal trade name, UAE telephone number, verified email address, and encrypted login credentials.</p>
        </div>

        <div class="data-card">
          <h3>Commercial Verification</h3>
          <p>Valid UAE Trade License details, registered facility address, TRN/VAT certificates, and Emirates ID copies for authorized signers.</p>
        </div>

        <div class="data-card">
          <h3>Machinery & Fleet Data</h3>
          <p>Registration cards (Mulkiya), technical specifications, maintenance logs, municipal inspection certificates, and operator credentials.</p>
        </div>

        <div class="data-card">
          <h3>Transactional Documentation</h3>
          <p>Local Purchase Orders (LPOs), timesheet records, invoices, device identifiers, and timestamped transaction audit logs.</p>
        </div>
      </div>
    </section>

    <section class="doc-section">
      <h2>3. Purpose of Processing</h2>
      <p>Your information is processed strictly for legitimate operational purposes:</p>
      <ul>
        <li>Enabling machinery rental discovery, scheduling, and direct commercial coordination.</li>
        <li>Verifying company legitimacy and preventing unauthorized access or fraud.</li>
        <li>Generating transactional documents (LPOs, Timesheets, and Quotations) at user request.</li>
        <li>Sending essential transactional notifications and operational updates.</li>
        <li>Fulfilling legal and statutory accounting retention requirements under UAE law.</li>
      </ul>
    </section>

    <section class="doc-section">
      <h2>4. Data Disclosure & Third Parties</h2>
      <p>
        <strong>Aluguloo does not sell, rent, or trade your personal or business data to third parties.</strong> Data is shared only:
      </p>
      <ul>
        <li><strong>Between Verified Counterparties:</strong> Necessary contact and site details are shared between the Customer and Vendor solely to complete accepted rental orders.</li>
        <li><strong>Cloud Infrastructure Providers:</strong> Secure hosting environments compliant with international ISO/IEC 27001 data security standards.</li>
        <li><strong>Statutory Authorities:</strong> Where mandated by law, court order, or official UAE governmental entity.</li>
      </ul>
    </section>

    <section class="doc-section">
      <h2>5. Security & Retention</h2>
      <p>
        All communications and transmissions are protected using TLS/SSL encryption. Passwords and sensitive credentials are encrypted using industry-standard cryptographic hashes.
      </p>
      <p>
        Commercial transaction logs, LPO records, and verification certificates are retained for a statutory minimum of 
        <strong>five (5) years</strong> in compliance with UAE commercial law.
      </p>
    </section>

    <section class="doc-section">
      <h2>6. Inquiries & Governance</h2>
      <p>
        For data access inquiries or account closure requests, please submit a request through your platform account settings or contact our corporate office:
      </p>
      <div class="contact-box">
        <div><strong>Entity:</strong> Onixhu LLC (Operating Aluguloo)</div>
        <div><strong>Support Channel:</strong> In-app account settings & security desk</div>
        <div><strong>Jurisdiction:</strong> Dubai & Sharjah, United Arab Emirates</div>
      </div>
    </section>
  </main>
</div>
